<div class="container">
  <app-search-bar></app-search-bar>
</div>
<div class="about-section mt-5 py-5">
  <div class="container">
    <app-about></app-about>
  </div>
</div>
